/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Referred/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Referred({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Referred",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#D546C7"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Referred.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-1PVawc': alignSelf,'--mt-2-1PVawc': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1PVawc': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1PVawc': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1PVawc': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1PVawc': opacity,'--w-10-1PVawc': typeof width === 'number' ? `${width}px` : width,'--h-11-1PVawc': typeof height === 'number' ? `${height}px` : height,'--f-12-1PVawc': fill,'--a-7-1PVawc': isAnimated ? animation : "none",'--sd-8-1PVawc': isAnimated ? strokeDashoffset : 0,'--sd-9-1PVawc': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Referred.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M13.25 7.5a2.75 2.75 0 10-2.747-2.62l-4 2a2.75 2.75 0 100 4.239l4 2a2.75 2.75 0 10.816-1.828L7.475 9.37a2.776 2.776 0 000-.74l3.844-1.922c.497.49 1.179.792 1.931.792z"
 style={{'--f-12-1PVawc': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}